import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { EnvService } from '../service/env.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';

@Component({
  selector: 'app-language-preference',
  templateUrl: './language-preference.component.html',
  styleUrls: ['./language-preference.component.scss']
})
export class LanguagePreferenceComponent implements OnInit {

  allSupportedLanguages;
  updateLanguagePreferrencesModel: any;
  updatedPreferredLanguages: any;
  @ViewChild('updateLanguagePreferrencesForm') public updateLanguagePreferrencesForm: NgForm;
  loggedInUser: any;
  account: any;
  @Output() routeToHomeEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private apiService: ApiService,
    public authService: AuthenticationService,
    private utilService: UtilService,
    private toast: ToastService,
    private env: EnvService,
    private toastService: ToastService,
  ) {
  }

  ngOnInit(): void {
  }

  updateLanguagePreferrences(form: NgForm) {
    if (!form.valid) return;
    console.log("update user modal::", this.updateLanguagePreferrencesModel);

    var payload = this.getUpdateLanguagePreferrencesPayload();

    this.utilService.showSpinner();
    this.apiService.updateLanguagePreference(payload, this.loggedInUser.userId).then((data) => {
      this.utilService.hideSpinner();
      this.toastService.showSuccess(data.message);
      // Update local data for user details too
      this.loggedInUser.name = payload.name;
      this.loggedInUser.phoneNumber = payload.phone;
      // if (this.loggedInUser.multiFactorAuthentication == 'ENABLED') {
      //   this.loggedInUser.mfaPreference = payload.mfaPreference;
      // }

      this.callRouteToHomeEmitter();
      document.getElementById("closeLanguagePreference").click();
      // this.initUpdateLanguagePreferrencesModel();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.updateLanguagePreferrences(form);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getAllSupportedLanguages() {
    this.utilService.showSpinner();
    this.apiService.getAllSupportedLanguages().then((data) => {
      this.utilService.hideSpinner();
      this.allSupportedLanguages = data;
      console.log("All supported languages::", this.allSupportedLanguages);
      this.initUpdateLanguagePreferrencesModel();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAllSupportedLanguages();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onLanguageSelected(checked: boolean, index: any) {
    this.allSupportedLanguages[index].ischecked = checked;
    this.updatedPreferredLanguages = this.allSupportedLanguages.filter(language => language.ischecked);
    this.updateLanguagePreferrencesModel.localeLanguages = this.updatedPreferredLanguages.map(preferredLanguage => preferredLanguage.locale);
  }

  initUpdateLanguagePreferrencesModel() {
    if (this.updateLanguagePreferrencesForm) {
      this.updateLanguagePreferrencesForm.reset();
      this.updateLanguagePreferrencesForm.resetForm();
    }
    setTimeout(() => {
      this.updateLanguagePreferrencesModel = {
        localeLanguages: null
      };
    }, 500);

    this.allSupportedLanguages.forEach(supportedLanguage => {
      supportedLanguage["ischecked"] = null
    });
  }

  getUpdateLanguagePreferrencesPayload() {
    let payload = JSON.parse(JSON.stringify(this.updateLanguagePreferrencesModel));

    return payload;
  }

  init() {
    this.loggedInUser = this.authService.loggedInUser;
    this.account = this.apiService.accountDetail;

    this.getAllSupportedLanguages();
    document.getElementById("openLanguagePreference").click();
    this.callRouteToHomeEmitter();
  }
  
  callRouteToHomeEmitter() {
    this.routeToHomeEmitter.emit();
  }
}
